<div class="modal-header">
    <h3 class="modal-title">Update Vendor</h3>
</div>
<div class="modal-body">
    <ng-select [items]="items$ | async"
               [(ngModel)]="selectedItem"
               [searchFn]="utilityService.noFilter"
               [bindLabel]="bindLabel"
               [placeholder]="placeholder"
               [minTermLength]="minTermLength"
               (clear)="setCleared()"
               typeToSearchText="Please enter {{minTermLength}} or more characters"
               [typeahead]="typeahead$"
    />
</div>
<div class="modal-footer">
    <!--    Could clear button be removed ?-->
    <button type="button" class="btn btn-default" (click)="clearSearchField()">{{ clearButtonText }}</button>
    <button type="button" class="btn btn-primary" (click)="saveAndCloseModal()" [disabled]="(!selectedItem && !cleared)">{{ saveButtonText }}</button>
    <button type="button" class="btn btn-default" (click)="cancelAndCloseModal()">{{ cancelButtonText }}</button>
</div>